import { put, call, select } from 'redux-saga/effects';
import { Types } from './actions';
import EventsRepository from '../../../../repositories/EventsRepository';
import EventsDataRepository from '../../../../../data/repositories/EventsDataRepository';
import XCheckpointManager from '@/core/managers/xcheckpointManager';

export const selectCurrentEvents = (state: any) =>
  state.getEventsByStudentScroll.data.eventsScrollType.events;
export const selectCurrentFeatures = (state: any) =>
  state.getEventsByStudentScroll.data.eventsScrollType.featured;
export default function* execute(action: any): any {
  try {
    const { eventType, page } = action;

    if (page <= 1) {
      yield put({ type: Types.GET_EVENTS_BY_STUDENT_SCROLL_REQUEST });
    } else {
      yield put({ type: Types.GET_EVENTS_BY_STUDENT_SCROLL_REQUEST_MORE });
    }
    XCheckpointManager.registerStart(`Eventos - ${eventType}`);
    const { data } = yield select((state: any) => state.profile);
    const eventsRepository: EventsRepository = new EventsDataRepository();
    const eventsResponse = yield call(
      eventsRepository.getEventsByStudentScroll,
      eventType,
      page,
      data.academic.career,
      data.academic.campus
    );
    if (!eventsResponse) {
      yield put({
        type: Types.GET_EVENTS_BY_STUDENT_SCROLL_FAILURE,
        error: true
      });
      return;
    }

    if (page > 1) {
      const currentEvents = yield select(selectCurrentEvents);
      const FeaturedEvents = yield select(selectCurrentFeatures);
      const updatedEvents = [
        ...currentEvents,
        ...eventsResponse.eventsScrollType.events
      ];
      const updatedFeatures = [
        ...FeaturedEvents,
        ...eventsResponse.eventsScrollType.featured
      ];
      const inComingEvents = {
        eventsScrollType: {
          events: updatedEvents,
          featured: updatedFeatures
        }
      };

      yield put({
        type: Types.GET_EVENTS_BY_STUDENT_SCROLL_REQUEST_SHOW_MORE,
        showMore:
          eventsResponse.eventsScrollType.events.length > 0 ||
          eventsResponse.eventsScrollType.featured.length > 0
      });
      yield put({
        type: Types.GET_EVENTS_BY_STUDENT_SCROLL_SUCCESS,
        data: inComingEvents
      });
    } else {
      yield put({
        type: Types.GET_EVENTS_BY_STUDENT_SCROLL_REQUEST_SHOW_MORE,
        showMore: true
      });
      yield put({
        type: Types.GET_EVENTS_BY_STUDENT_SCROLL_SUCCESS,
        data: eventsResponse
      });
    }
    XCheckpointManager.registerEnd(`Eventos - ${eventType}`);
  } catch (error) {
    yield put({
      type: Types.GET_EVENTS_BY_STUDENT_SCROLL_FAILURE,
      error: 'Ocurrió un error al momento de leer los datos de los eventos.'
    });
  }
}
